import { RouteRecordRaw } from "vue-router"

const ChambautRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "chambaut-home",
    redirect: "/data-overview"
  },
  {
    path: "/data-overview",
    name: "data-overview",
    meta: {
      title: "数据概览",
      icon: "Grid"
    },
    redirect: "/data-overview/promotion-list-v2",
    component: () => import("@/layouts/index.vue"),
    children: [
      // {
      //   path: "performance-statistics",
      //   name: "performance-statistics",
      //   meta: {
      //     title: "绩效统计"
      //   },
      //   component: () => import("@/views/DataOverview/PerformanceStatistics/index.vue")
      // },
      //
      // {
      //   path: "promotion-list",
      //   name: "promotion-list",
      //   meta: {
      //     title: "推广列表"
      //   },
      //   component: () => import("@/views/DataOverview/promotionList/index.vue")
      // },
      // {
      //   path: "tik-tok-promotion-list-v2",
      //   name: "tik-tok-promotion-list-v2",
      //   meta: {
      //     title: "推广列表"
      //   },

      //   component: () => import("@/views/DataOverview/promotionListV2/TikTok/index.vue")
      // },
      {
        path: "promotion-list-v2",
        name: "promotion-list-v2",
        meta: {
          title: "推广列表V2"
          // hidden: process.env.NODE_ENV !== 'development',
        },
        redirect: "/data-overview/promotion-list-v2/tik-tok-promotion-list-v2",
        children: [
          {
            path: "tik-tok-promotion-list-v2",
            name: "tik-tok-promotion-list-v2",
            meta: {
              title: "抖音推广列表"
            },
            component: () => import("@/views/DataOverview/promotionListV2/TikTok/index.vue")
          },
          {
            path: "ks-promotion-list-v2",
            name: "ks-promotion-list-v2",
            meta: {
              title: "快手推广列表"
            },
            component: () => import("@/views/DataOverview/promotionListV2/KuaiShou/index.vue")
          }
        ]
      },

      // {
      //   path: "Tik-tok-data-distribution",
      //   name: "Tik-tok-data-distribution",
      //   meta: {
      //     title: "数据分配"
      //     // hidden: process.env.NODE_ENV !== "development"
      //   },
      //   component: () => import("@/views/DataOverview/TiktokDataDistribution/index.vue")
      // },
      {
        path: "distribution",
        meta: {
          title: "数据分配"
          // hidden: process.env.NODE_ENV !== 'development',
        },
        redirect: "/data-overview/distribution/tik-tok-order-details",
        children: [
          {
            path: "Tik-tok-data-distribution",
            name: "Tik-tok-data-distribution",
            meta: {
              title: "抖音数据分配"
              // hidden: process.env.NODE_ENV !== 'development',
            },
            component: () => import("@/views/DataOverview/TiktokDataDistribution/index.vue")
          },
          {
            path: "Ks-data-distribution",
            name: "Ks-data-distribution",
            meta: {
              title: "快手数据分配"
            },
            component: () => import("@/views/DataOverview/Ks_DataDistribution/index.vue")
          }
        ]
      },
      // {
      //   path: "Tik-tok-data-distribution/:id",
      //   name: "Tik-tok-data-distribution-details",
      //   meta: {
      //     title: "数据分配 - 详情",
      //     hidden: true
      //   },
      //   component: () => import("@/views/DataOverview/DataDistributionDetails/index.vue")
      // },
      {
        path: "distribution/Tik-tok-data-distribution/:id",
        name: "distribution/Tik-tok-data-distribution-details",
        meta: {
          title: "抖音数据分配 - 详情",
          hidden: true
        },
        component: () => import("@/views/DataOverview/DataDistributionDetails/index.vue")
      },
      {
        path: "distribution/Ks-data-distribution/:id",
        name: "distribution/Ks-data-distribution",
        meta: {
          title: "快手数据分配 - 详情",
          hidden: true
        },
        component: () => import("@/views/DataOverview/Ks_DataDistributionDetails/index.vue")
      },
      {
        path: "data-distribution/:id",
        name: "data-distribution-details",
        meta: {
          title: "数据分配 - 详情",
          hidden: true
        },
        component: () => import("@/views/DataOverview/DataDistributionDetails/index.vue")
      },
      // {
      //   path: "tik-tok-order-details",
      //   name: "tik-tok-order-details",
      //   meta: {
      //     title: "订单明细"
      //     // hidden: process.env.NODE_ENV !== "development"
      //   },
      //   component: () => import("@/views/DataOverview/tiktokOrderDetails/index.vue")
      // }
      {
        path: "order-details",

        meta: {
          title: "订单明细"
        },
        redirect: "/data-overview/order-details/tik-tok-order-details",
        children: [
          {
            path: "tik-tok-order-details",
            name: "tik-tok-order-details",
            meta: {
              title: "抖音订单明细"
              // hidden: process.env.NODE_ENV !== 'development',
            },
            component: () => import("@/views/DataOverview/tiktokOrderDetails/index.vue")
          },
          {
            path: "KS-order-details",
            name: "KS-order-details",
            meta: {
              title: "快手订单明细"
            },
            component: () => import("@/views/DataOverview/KsOrderDetails/index.vue")
          }
        ]
      }
    ]
  },
  {
    path: "/order-management",
    name: "order-management",
    meta: {
      title: "订单管理",
      icon: "Document"
    },
    redirect: "/order-management/tik-tok-channel-order",
    component: () => import("@/layouts/index.vue"),
    children: [

      // {
      //   path: "tik-tok-channel-order",
      //   name: "tik-tok-channel-order",
      //   meta: {
      //     title: "渠道订单"
      //   },
      //   component: () => import("@/views/OrderManagement/ChannelOrder/TikTok/index.vue")
      // },


      {
        path: "channel-order",
        name: "channel-order",
        meta: {
          title: "渠道订单"
        },
        redirect: "/order-management/channel-order/tik-tok-channel-order",
        children: [
          {
            path: "tik-tok-channel-order",
            name: "tik-tok-channel-order",
            meta: {
              title: "抖音渠道订单"
            },
            component: () => import("@/views/OrderManagement/ChannelOrder/TikTok/index.vue")
          },
          {
            path: "ks-channel-order",
            name: "ks-channel-order",
            meta: {
              title: "快手渠道订单"
            },
            component: () => import("@/views/OrderManagement/ChannelOrder/KuaiShou/index.vue")
          }
        ]
      },
      // {
      //   path: "supplementary-specimen",
      //   meta: {
      //     title: "补样订单"
      //   },
      //   component: () => import("@/views/OrderManagement/SupplementarySpecimen/index.vue")
      // }
      {
        path: "Replenishment_order",
        meta: {
          title: "补样订单"
        },
        redirect: "/order-management/Replenishment_order/supplementary-specimen",
        children: [
          {
            path: "supplementary-specimen",
            name: "supplementary-specimen",
            meta: {
              title: "抖音补样订单"

            },
            component: () => import("@/views/OrderManagement/SupplementarySpecimen/index.vue")
          },
          {
            path: "Ks_supplementary-specimen",
            name: "Ks_supplementary-specimen",
            meta: {
              title: "快手补样订单"
            },
            component: () => import("@/views/OrderManagement/Ks_SupplementarySpecimen/index.vue")
          }
        ]
      }
    ]
  },
  // {
  //   path: "/rebate-expenditure",
  //   name: "RebateExpenditure",
  //   meta: {
  //     title: "薪酬设置"
  //   },
  //   component: () => import("@/views/FinancialManagement/RebateExpenditure.vue")
  // },
  {
    path: "/master-management",
    name: "master-management",
    meta: {
      title: "达人管理",
      icon: "StarFilled"
    },
    redirect: "/master-management/master-list",
    component: () => import("@/layouts/index.vue"),
    children: [
      // {
      //   path: "master-list",
      //   name: "master-list",
      //   meta: {
      //     title: "达人列表"
      //   },
      //   component: () => import("@/views/TalentManagement/MasterList/index.vue")
      // },
      {
        path: "master-list",
        meta: {
          title: "达人列表"
        },
        redirect: "/master-management/master-list/master-list",
        children: [
          {
            path: "master-list",
            name: "master-list",
            meta: {
              title: "抖音达人列表"
            },
            component: () => import("@/views/MasterManagement/MasterList/index.vue")
          },
          {
            path: "Ks-master-list",
            name: "Ks-master-list",
            meta: {
              title: "快手达人列表"
            },
            component: () => import("@/views/KsMasterManagement/MasterList/index.vue")
          }
        ]
      },
      // {
      //   path: "open-sea-master-list",
      //   name: "open-sea-master-list",
      //   meta: {
      //     title: "公海达人列表"
      //   },
      //   component: () => import("@/views/TalentManagement/OpenSeaMasterList/index.vue")
      // },
      {
        path: "open-sea-master-list",
        meta: {
          title: "公海达人列表"
        },
        redirect: "/master-management/open-sea-master-list/open-sea-master-list",
        children: [
          {
            path: "open-sea-master-list",
            name: "open-sea-master-list",
            meta: {
              title: "抖音公海达人列表"
            },
            component: () => import("@/views/MasterManagement/OpenSeaMasterList/index.vue")
          },
          {
            path: "Ks-open-sea-master-list",
            name: "Ks-open-sea-master-list",
            meta: {
              title: "快手公海达人列表"
            },
            component: () => import("@/views/MasterManagement/Ks_OpenSeaMasterList/index.vue")
          }
        ]
      },
      {
        path: "open-sea-master-review",
        name: "open-sea-master-review",
        meta: {
          title: "公海达人审核"
        },
        component: () => import("@/views/MasterManagement/OpenSeaMasterReview/index.vue")
      }
    ]
  },
  {
    path: "/product-management",
    name: "product-management",
    meta: {
      title: "产品管理",
      icon: "ShoppingCart"
    },
    redirect: "/product-management/tik-tok-product-list",
    component: () => import("@/layouts/index.vue"),
    children: [
      // {
      //   path: "tik-tok-product-list",
      //   name: "tik-tok-product-list",
      //   meta: {
      //     title: "产品列表"
      //     // hidden: true
      //   },
      //   component: () => import("@/views/ProductManagement/ProductList/TikTokProductList/index.vue")
      // },

      {
        path: "product-list",
        name: "product-list",
        meta: {
          title: "产品列表"
        },
        redirect: "/product-management/product-list/tik-tok-product-list",
        children: [
          {
            path: "tik-tok-product-list",
            name: "tik-tok-product-list",
            meta: {
              title: "抖音产品列表"
              // hidden: true
            },
            component: () => import("@/views/ProductManagement/ProductList/TikTokProductList/index.vue")
          },
          {
            path: "ks-product-list",
            name: "ks-product-list",
            meta: {
              title: "快手产品列表"
              // hidden: true
            },
            component: () => import("@/views/ProductManagement/ProductList/KSProductList/index.vue")
          }
        ]
      },
      // {
      //   path: "tik-tok-product-area",
      //   name: "tik-tok-product-area",
      //   meta: {
      //     title: "产品专区"
      //     // hidden: true
      //   },
      //   component: () => import("@/views/ProductManagement/ProductArea/TikTokProductArea/index.vue")
      // },

      {
        path: "product-area",
        name: "product-area",
        meta: {
          title: "产品专区"
        },
        redirect: "/product-management/product-area/tik-tok-product-area",
        children: [
          {
            path: "tik-tok-product-area",
            name: "tik-tok-product-area",
            meta: {
              title: "抖音产品专区"
              // hidden: true
            },
            component: () => import("@/views/ProductManagement/ProductArea/TikTokProductArea/index.vue")
          },
          {
            path: "ks-product-area",
            name: "ks-product-area",
            meta: {
              title: "快手产品专区"
              // hidden: true
            },
            component: () => import("@/views/ProductManagement/ProductArea/KSProductArea/index.vue")
          }
        ]
      },
      {
        path: "product-area-details",
        name: "product-area-details",
        meta: {
          title: "专区详情",
          hidden: true
        },
        redirect: "/product-management/product-area-details/tik-tok-product-area-details",
        children: [
          {
            path: "tik-tok-product-area-details",
            name: "tik-tok-product-area-details",
            meta: {
              title: "抖音专区详情"
              // hidden: true
            },
            component: () => import("@/views/ProductManagement/ProductAreaDetails/TikTokProductAreaDetails/index.vue")
          },
          {
            path: "ks-product-area-details",
            name: "ks-product-area-details",
            meta: {
              title: "快手专区详情"
              // hidden: true
            },
            component: () => import("@/views/ProductManagement/ProductAreaDetails/KSProductAreaDetails/index.vue")
          }
        ]
      }
    ]
  },
  // {
  //   path: "/company-management",
  //   name: "CompanyManagement",
  //   meta: {
  //     title: "组织管理",
  //     icon: "Switch"
  //   },
  //   redirect: "/company-management/company-management",
  //   component: () => import("@/layouts/index.vue"),
  //   children: [
  //     {
  //       path: "company-management",
  //       name: "CompanyManagement",
  //       meta: {
  //         title: "公司管理"
  //       },
  //       component: () => import("@/views/OrganizationManagement/CompanyManagement/index.vue")
  //     },
  //     {
  //       path: "department-management",
  //       name: "DepartmentManagement",
  //       meta: {
  //         title: "部门管理"
  //       },
  //       component: () => import("@/views/OrganizationManagement/DepartmentManagement/index.vue")
  //     },
  //     {
  //       path: "employee-management",
  //       name: "EmployeeManagement",
  //       meta: {
  //         title: "员工管理"
  //       },
  //       component: () => import("@/views/OrganizationManagement/EmployeeManagement/index.vue")
  //     }
  //   ]
  // },
  {
    path: "/configuration-management",
    name: "configuration-management",
    meta: {
      title: "配置管理",
      icon: "Setting"
    },
    redirect: "/configuration-management/pc-carousel",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "pc-carousel",
        name: "pc-carousel",
        meta: {
          title: "PC轮播图"
        },
        component: () => import("@/views/ConfigurationManagement/PcCarousel/index.vue")
      },
      {
        path: "express-logistics",
        name: "express-logistics",
        meta: {
          title: "快递物流记录"
        },
        component: () => import("@/views/ConfigurationManagement/ExpressLogistics/index.vue")
      },
      {
        path: "ai-usage-records",
        name: "ai-usage-records",
        meta: {
          title: "AI使用记录"
        },
        component: () => import("@/views/ConfigurationManagement/AiUsageRecords/index.vue")
      }
      // {
      //   path: "pc-carousel",
      //   name: "pc-carousel",
      //   meta: {
      //     title: "文章列表"
      //   },
      //   component: () => import("@/views/ConfigurationManagement/PcCarousel/index.vue")
      // },
      // {
      //   path: "express-logistics",
      //   name: "express-logistics",
      //   meta: {
      //     title: "文章发布"
      //   },
      //   component: () => import("@/views/ConfigurationManagement/ExpressLogistics/index.vue")
      // },
      // {
      //   path: "tik-tok-authorization-management",
      //   name: "tik-tok-authorization-management",
      //   meta: {
      //     title: "抖音授权管理"
      //   },
      //   component: () => import("@/views/ConfigurationManagement/AuthorizationManagement/TikTokAuthorizationManagement/index.vue")
      // }
    ]
  }
]

export default ChambautRoutes
